import axios, {AxiosResponse} from 'axios'
const api = '/api/'

const campusList = async ({params}) => {
  const response = await axios.get(`${api}campus/list`, params)
  return response.data
}

const campusCreate = async ({data}) => {
  await axios.post(`${api}campus/store`, data)
}

const campusEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}campus/edit/${id}`)
  return response.data
}

const campusDelete = async (id: string) => {
  await axios.get(`${api}campus/destroy/${id}`)
}

const campusUnitList = async ({params}) => {
  const response = await axios.get(`${api}campus-unit/list`, params)
  return response.data
}

const campusUnitCreate = async ({data}) => {
  await axios.post(`${api}campus-unit/store`, data)
}

const campusUnitEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}campus-unit/edit/${id}`)
  return response.data
}

const campusUnitDelete = async (id: string) => {
  await axios.get(`${api}campus-unit/destroy/${id}`)
}

const campusUnitView = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}campus-unit/view/${id}`)
  return response.data
}

const GradingList = async () => {
  const response = await axios.get(`${api}grading/list`)
  return response.data
}

const facultyList = async ({params}) => {
  const response = await axios.get(`${api}faculty/list`, params)
  return response.data
}

const facultyCreate = async ({data}) => {
  await axios.post(`${api}faculty/store`, data)
}

const facultyEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}faculty/edit/${id}`)
  return response.data
}

const facultyDelete = async (id: string) => {
  await axios.get(`${api}faculty/destroy/${id}`)
}

const departmentList = async (faculty_id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}faculty/dep-list/${faculty_id}`)
  return response.data
}

const departmentCreate = async ({data}) => {
  await axios.post(`${api}faculty/dep-store`, data)
}

const departmentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}faculty/dep-edit/${id}`)
  return response.data
}

const departmentDelete = async (id: string) => {
  await axios.get(`${api}faculty/dep-destroy/${id}`)
}

const cuFacultyList = async ({params}) => {
  const response = await axios.get(`${api}cu-faculty/list`, params)
  return response.data
}

const cuFacultyCreate = async ({data}) => {
  await axios.post(`${api}cu-faculty/store`, data)
}

const cuFacultyEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}cu-faculty/edit/${id}`)
  return response.data
}

const cuFacultyDelete = async (id: string) => {
  await axios.get(`${api}cu-faculty/destroy/${id}`)
}

const cuDepartmentList = async ({params}) => {
  const response = await axios.get(`${api}cu-department/list`, params)
  return response.data
}

const cuDepartmentCreate = async ({data}) => {
  await axios.post(`${api}cu-department/store`, data)
}

const cuDepartmentEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}cu-department/edit/${id}`)
  return response.data
}

const cuDepartmentDelete = async (id: string) => {
  await axios.get(`${api}cu-department/destroy/${id}`)
}

const getDeps = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}cu-faculty/get-deps/${id}`)
  return response.data
}

const subjectList = async ({params}) => {
  const response = await axios.get(`${api}subject/list`, params)
  return response.data
}

const subjectCreate = async ({data}) => {
  await axios.post(`${api}subject/store`, data)
}

const subjectEdit = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}subject/edit/${id}`)
  return response.data
}

const subjectSwitchStatus = async (id: string) => {
  const response = await axios.get(`${api}subject/switch-status/${id}`)
  return response.data
}

const campusService = {
  subjectList,
  subjectCreate,
  subjectEdit,
  subjectSwitchStatus,
  getDeps,
  cuDepartmentList,
  cuDepartmentCreate,
  cuDepartmentEdit,
  cuDepartmentDelete,
  cuFacultyList,
  cuFacultyCreate,
  cuFacultyEdit,
  cuFacultyDelete,
  facultyList,
  facultyCreate,
  facultyEdit,
  facultyDelete,
  departmentList,
  departmentCreate,
  departmentEdit,
  departmentDelete,
  campusList,
  campusCreate,
  campusEdit,
  campusDelete,
  campusUnitList,
  campusUnitCreate,
  campusUnitEdit,
  campusUnitDelete,
  campusUnitView,
  GradingList,
}

export default campusService
